import axios from "axios";
import authHeader from "./auth-header";

const API_URL = "https://eco2wo.com/api/";

const getPublicContent = () => {
  return { then: () => "Ok!" }
};

const getUserBoard = () => {
  return { then: () => "Ok" }; // axios.get(API_URL + "user", { headers: authHeader() });
};

const getModeratorBoard = () => {
  return axios.get(API_URL + "mod", { headers: authHeader() });
};

const getAdminBoard = () => {
  return axios.get(API_URL + "admin", { headers: authHeader() });
};

const userService = {
  getPublicContent,
  getUserBoard,
  getModeratorBoard,
  getAdminBoard,
};

export default userService